import React, { useState, useRef } from "react";
import Modal from "../../../components/modal/index";
import toast from "react-hot-toast";
import api from "../../../services/api";

const TransferAmountModal = ({
  isModalOpen,
  setIsModalOpen,
  selectedOfferSlotIds,
  transferAmount,
  teacherId,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  const [isDisabled, setIsDisabled] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);

      // Create a preview URL for the file
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setSelectedFile(file);

      // Create a preview URL for the file
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const removeFile = (e) => {
    e.stopPropagation();
    setSelectedFile(null);
    setPreviewUrl(null);
    fileInputRef.current.value = "";
  };

  const handleSubmit = async () => {
    setIsDisabled(true);
    if (!selectedFile) {
      toast.error("Receipt is required");
      return;
    }
    try {
      let formData = new FormData();
      formData.append("file", selectedFile);
      const receiptUpload = await api.post(
        //upload receipt
        "/upload",
        formData
      );
      const data = {
        offerSlotsIds: selectedOfferSlotIds,
        teacherId: teacherId,
        receiptUrl: receiptUpload.data?.data?.url,
        amount: transferAmount,
      };
      const response = await api.post(
        // post data
        "/admin/transfer/teacher",
        data
      );
      setIsModalOpen(false);
      toast.success("Payment transfered Successfully");
    } catch (error) {
      console.log(error);
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <Modal
      width={700}
      show={isModalOpen}
      onCancel={() => {
        setIsModalOpen(!isModalOpen);
      }}
    >
      <div className="p-3">
        <h5 className="mb-3">Upload Receipt</h5>

        <div
          className="upload-area border rounded text-center position-relative bg-light"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={!previewUrl ? triggerFileInput : undefined}
          style={{
            cursor: !previewUrl ? "pointer" : "default",
            borderStyle: "dashed",
            borderColor: "#dee2e6",
            minHeight: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <input
            type="file"
            className="d-none"
            onChange={handleFileChange}
            ref={fileInputRef}
            accept="image/*,.pdf"
          />

          {!previewUrl ? (
            <div className="upload-placeholder d-flex flex-column align-items-center justify-content-center">
              <i className="bi bi-cloud-arrow-up fs-1 mb-3 text-secondary"></i>
              <p className="mb-1">
                Drag and drop your receipt here or click to browse
              </p>
              <p className="text-muted small">
                Supported formats: JPG, PNG, PDF
              </p>
            </div>
          ) : (
            <div className="preview-container w-100 d-flex flex-column align-items-center">
              {selectedFile.type.includes("image") ? (
                <div
                  className="image-preview-container"
                  style={{
                    width: "100%",
                    // maxWidth: "300px",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={previewUrl}
                    alt="Receipt preview"
                    className="img-preview img-fluid"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "150px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              ) : (
                <div
                  className="pdf-preview d-flex align-items-center justify-content-center"
                  style={{ width: "100%" }}
                >
                  <div className="text-center">
                    <i className="bi bi-file-earmark-pdf fs-1 text-danger"></i>
                    <p className="mt-2 mb-0">{selectedFile.name}</p>
                  </div>
                </div>
              )}

              <div className="file-info mt-2 text-center">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={removeFile}
                  style={{
                    borderColor: "#dc3545",
                    color: "#dc3545",
                    padding: "0.25rem 0.75rem",
                  }}
                >
                  <i className="bi bi-trash me-1"></i> Remove
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="px-3 pb-2 pt-3">
        <div className="d-flex justify-content-end align-items-end">
          <span className="fw-bold text-end">
            Total Amount :<b className="mx-4">RS {transferAmount}</b>{" "}
          </span>
        </div>
      </div>

      <div className="d-flex justify-content-end p-3">
        <button
          type="button"
          onClick={() => setIsModalOpen(false)}
          className="btn btn-outline-dark me-2"
          style={{
            borderRadius: "4px",
            padding: "0.375rem 1.5rem",
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-dark"
          disabled={
            (!selectedFile && !selectedOfferSlotIds?.length) || isDisabled
          }
          style={{
            borderRadius: "4px",
            padding: "0.375rem 1.5rem",
            backgroundColor: "#212529",
          }}
          onClick={handleSubmit}
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default TransferAmountModal;
